import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Footer from '@design-system/footer';
import Navbar from '@design-system/navbar';
import { getUser } from '@app/auth/redux/selectors';
import { useSelector } from 'react-redux';

const Main = styled.main`
  display: flex;
  margin: 0;
  padding: 0;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 100vh;

  .container {
    border: 1px solid red;
  }
`;

export const MainLayout = ({ children }) => {
  const user = useSelector(getUser);

  return (
    <Main>
      <Navbar user={user} />
      <main>{children}</main>
      <Footer />
    </Main>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
